import $ from "jquery"; // Remove me if jQuery isn't necessary

import utils from "../helpers/utils";

function init(): void {
  const $breadcrumbItem = $(".js-breadcrumb-item");
  if ($breadcrumbItem.length && $breadcrumbItem.length > 2) {
    const $breadcrumbDots = $(".js-breadcrumb-dots");
    const $breadcrumbList = $(".js-breadcrumb-list");
    const controls = $breadcrumbList.attr("id");
    // As per https://a11yproject.com/patterns/ for a toggle button
    $breadcrumbDots.attr("aria-haspopup", "true");
    $breadcrumbDots.attr("aria-controls", controls);
    $breadcrumbList.removeClass("active");
    $breadcrumbList.attr("aria-hidden", "true");
    $breadcrumbList.attr("role", "listbox");

    $breadcrumbDots.click(() => {
      const hiddenStr = $breadcrumbList.attr("aria-hidden");
      const hidden = utils.convertToBoolean(hiddenStr);
      $breadcrumbList.toggleClass("active");
      $breadcrumbList.attr("aria-hidden", (!hidden).toString());

      const $ellipsisList = $breadcrumbDots.find(".js-breadcrumb-ellipsis");
      if ($ellipsisList.length > 0) {
        const $ellipsisItem = $($ellipsisList[0]);
        const expandedStr = $ellipsisItem.attr("aria-expanded");
        const expanded = utils.convertToBoolean(expandedStr);
        $ellipsisItem.attr("aria-expanded", (!expanded).toString());
      }
    });
  }
}

export default { init };
